import { Suspense, lazy } from 'react';
import Navbar from '../components/Navbar.jsx';
import HeroSection from '../components/hero/HeroSection.jsx';

const ServicesSection = lazy(
  () => import('../components/services/ServicesSection.jsx')
);
const ProjectsSection = lazy(
  () => import('../components/projects/ProjectsSection.jsx')
);
const DiagnosticSection = lazy(
  () => import('../components/diagnostic/DiagnosticSection.jsx')
);
const MethodologySection = lazy(
  () => import('../components/methodology/MethodologySection.jsx')
);
const CtaSection = lazy(() => import('../components/cta/CtaSection.jsx'));
const ContactSection = lazy(
  () => import('../components/contact/ContactSection.jsx')
);
const Footer = lazy(() => import('../components/footer/Footer.jsx'));

function HomePage() {
  return (
    <>
      <Navbar />
      <main className='min-h-screen bg-background-dark'>
        <HeroSection />
        <Suspense fallback={null}>
          <ServicesSection />
          <ProjectsSection />
          <DiagnosticSection />
          <MethodologySection />
          <CtaSection />
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </>
  );
}

export default HomePage;
